import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThankYouShell from "./ThankYouShell";
import s from "./ThankYouShell.module.scss";

const ThankYou: React.FC = () => {
  const location1 = useLocation();

  const { t, i18n } = useTranslation();
  if ((location1 as any)?.state?.language) {
    i18n.changeLanguage((location1 as any)?.state?.language);
  }

  // Determine icon & titles based on condition
  let icon = "mdi-checkbox-marked-circle-outline";
  let title = "Thank You!";
  let subtitle = "We appreciate your submission and participation with LOVESTRONG.";

  if (location1?.state?.condition === "priestRegister") {
    icon = "mdi-account-check-outline";
    title = t("thank_you_for_prtiest");
    subtitle = "Your registration has been submitted successfully.";
  } else if (location1?.state?.condition === "New Register Retreat") {
    icon = "mdi-calendar-check";
    title = t("thank_you_retreat_registration");
    subtitle = t("We_will_review_and_confirm");
  } else if (location1?.state === "Profile") {
    icon = "mdi-account-cog-outline";
    title = "Profile Updated!";
    subtitle = "Thank you for updating your profile information.";
  } else if (location1?.state?.value === "New Register Couple") {
    icon = "mdi-heart-circle-outline";
    title = t("couple_register_retreat_msg");
    subtitle = t("check_email_and_verify");
  } else if (location1?.state?.value === "Register WaitList Couple") {
    icon = "mdi-clock-check-outline";
    title = "Waitlist Confirmed!";
    subtitle = "You have successfully joined the retreat waitlist.";
  }

  return (
    <ThankYouShell
      icon={icon}
      title={title}
      subtitle={subtitle}
      actions={
        <div className={s.actions}>
          <Link to="/login" className={s.primaryBtn}>
            {t("login")}
          </Link>
          <Link to="/forgetPassword" className={s.secondaryBtn}>
            {t("forget_password")}
          </Link>
        </div>
      }
    >
      <div>
        {/* Priest Registration */}
        {location1 &&
        location1.state &&
        location1.state.condition === "priestRegister" ? (
          <div className="text-center py-2">
            <p className="text-muted fs-6 mb-0">
              Thank you for registering as a Priest with LOVESTRONG Marriage. Our team will review your account details.
            </p>
          </div>
        ) : location1 &&
          location1.state &&
          location1.state.condition === "New Register Retreat" ? (
          <div className="text-center py-2">
            <p className="text-muted fs-6 mb-0">
              We look forward to having you! A confirmation email will be sent once your retreat registration is finalized.
            </p>
          </div>
        ) : (
          <div>
            {/* Profile Update */}
            {location1 && location1.state === "Profile" ? (
              <div className="text-center py-2">
                <p className="text-muted fs-6 mb-0">
                  Your profile details have been saved successfully. You can now log back into your account.
                </p>
              </div>
            ) : location1?.state?.value === "New Register Couple" ? (
              <>
                {location1.state.data?.mail_msg ? (
                  <>
                    <div
                      className="mb-3 text-center"
                      dangerouslySetInnerHTML={{
                        __html: location1.state.data.mail_msg,
                      }}
                    />
                    {location1?.state?.data?.paymentLink ? (
                      <div className="p-3 bg-light rounded-3 mt-3 text-center">
                        <span className="d-block fw-bold text-dark mb-1">
                          {t("retreat_payment_link")}
                        </span>
                        <a
                          href={location1?.state?.data?.paymentLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="fw-bold"
                          style={{
                            color: "#1F3BB3",
                            textDecoration: "underline",
                          }}
                        >
                          {location1?.state?.data?.paymentLink}
                        </a>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <div className="text-center py-2">
                    <p className="text-muted fs-6 mb-0">{t("check_email_and_verify")}</p>
                  </div>
                )}
              </>
            ) : location1?.state?.value === "Register WaitList Couple" ? (
              /* WaitList */
              <div className="text-center py-2">
                <h5 className="fw-bold mb-3" style={{ color: "#1E283D", lineHeight: 1.4 }}>
                  Thank you for joining the waitlist for the “
                  <span style={{ color: "#1F3BB3" }}>
                    {`${location1?.state?.data?.myparish?.parish || ""}`} LOVESTRONG Marriage
                  </span>
                  ” retreat.
                </h5>
                <p className="text-muted fs-6 mb-0">
                  We’re delighted about your interest and look forward to welcoming you to a future retreat!
                </p>
              </div>
            ) : (
              <>
                {location1?.state?.data?.mail_msg ? (
                  <>
                    <div
                      className="mb-3 text-center"
                      dangerouslySetInnerHTML={{
                        __html: location1.state.data.mail_msg,
                      }}
                    />
                    {location1?.state?.data?.paymentLink ? (
                      <div className="p-3 bg-light rounded-3 mt-3 text-center">
                        <span className="d-block fw-bold text-dark mb-1">
                          {t("retreat_payment_link")}
                        </span>
                        <a
                          href={location1?.state?.data?.paymentLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="fw-bold"
                          style={{
                            color: "#1F3BB3",
                            textDecoration: "underline",
                          }}
                        >
                          {location1?.state?.data?.paymentLink}
                        </a>
                      </div>
                    ) : null}
                  </>
                ) : (
                  <div className="text-center py-2">
                    <p className="text-muted fs-6 mb-2">
                      {t("wait_confirmation_aAdmin")}
                    </p>
                    <p className="fw-bold text-dark mb-2">
                      {t("can_login_your_account")}
                    </p>
                    {(location1?.state?.hisEmail || location1?.state?.herEmail) && (
                      <p className="text-muted small mb-0">
                        {location1.state?.hisEmail || ""}
                        {location1.state?.hisEmail && location1.state?.herEmail
                          ? " Or "
                          : ""}
                        {location1.state?.herEmail || ""}
                      </p>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </ThankYouShell>
  );
};

export default ThankYou;


